<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Tarifas por Persona</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Tarifa</button>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nueva Tarifa</h5>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Cantidad de Personas</label>
            <input v-model.number="nuevaTarifa.CantidadPersonas" type="number" min="1" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Precio (Q)</label>
            <input v-model.number="nuevaTarifa.Precio" type="number" min="0" step="0.01" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Tipo de Habitación</label>
            <select v-model="nuevaTarifa.IdTipoHabitacion" class="form-select">
              <option disabled value="">Seleccione un tipo</option>
              <option v-for="tipo in tiposHabitacion" :key="tipo.IdTipoHabitacion" :value="tipo.IdTipoHabitacion">
                {{ tipo.Nombre }}
              </option>
            </select>
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarTarifa">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Tipo de Habitación</th>
              <th>Personas</th>
              <th>Precio (Q)</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="tarifas.length === 0">
              <td colspan="4">No hay tarifas registradas.</td>
            </tr>
            <tr v-for="tarifa in tarifas" :key="tarifa.IdTarifaPersona">
              <td>{{ tarifa.tipo_habitacion?.Nombre }}</td>
              <td>{{ tarifa.CantidadPersonas }}</td>
              <td>Q{{ tarifa.Precio }}</td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(tarifa)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(tarifa)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Tarifa</h5>
            <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Cantidad de Personas</label>
                <input v-model.number="tarifaEditar.CantidadPersonas" type="number" min="1" class="form-control" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Precio (Q)</label>
                <input v-model.number="tarifaEditar.Precio" type="number" min="0" step="0.01" class="form-control" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Tipo de Habitación</label>
                <select v-model="tarifaEditar.IdTipoHabitacion" class="form-select">
                  <option disabled value="">Seleccione un tipo</option>
                  <option v-for="tipo in tiposHabitacion" :key="tipo.IdTipoHabitacion" :value="tipo.IdTipoHabitacion">
                    {{ tipo.Nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarTarifa">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar la tarifa para <strong>{{ tarifaEliminar?.tipo_habitacion?.Nombre }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "TarifaPersonaGestion",
  data() {
    return {
      tarifas: [],
      tiposHabitacion: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      tarifaEditar: null,
      tarifaEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevaTarifa: {
        CantidadPersonas: "",
        Precio: "",
        IdTipoHabitacion: "",
      },
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerTarifas() {
      const res = await axios.get(`${API_URL}/precios-habitaciones`);
      this.tarifas = res.data;
    },
    async obtenerTiposHabitacion() {
      const res = await axios.get(`${API_URL}/tipohabitacion`);
      this.tiposHabitacion = res.data;
    },
    async guardarTarifa() {
      const { CantidadPersonas, Precio, IdTipoHabitacion } = this.nuevaTarifa;
      if (!CantidadPersonas || !Precio || !IdTipoHabitacion) {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/precios-habitaciones`, this.nuevaTarifa);
        this.mostrarAlerta("Tarifa agregada", "success");
        this.nuevaTarifa = { CantidadPersonas: "", Precio: "", IdTipoHabitacion: "" };
        this.mostrarFormulario = false;
        this.obtenerTarifas();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar", "danger");
      }
    },
    abrirModal(tarifa) {
      this.tarifaEditar = { ...tarifa };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.tarifaEditar = null;
      this.mostrarModal = false;
    },
    async actualizarTarifa() {
      try {
        await axios.put(`${API_URL}/precios-habitaciones/${this.tarifaEditar.IdTarifaPersona}`, this.tarifaEditar);
        this.mostrarAlerta("Tarifa actualizada", "success");
        this.cerrarModal();
        this.obtenerTarifas();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(tarifa) {
      this.tarifaEliminar = { ...tarifa };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.tarifaEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      if (!this.tarifaEliminar) return;
      try {
        await axios.delete(`${API_URL}/precios-habitaciones/${this.tarifaEliminar.IdTarifaPersona}`);
        this.mostrarAlerta("Tarifa eliminada", "success");
        this.obtenerTarifas();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevaTarifa = { CantidadPersonas: "", Precio: "", IdTipoHabitacion: "" };
    },
  },
  mounted() {
    this.obtenerTarifas();
    this.obtenerTiposHabitacion();
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
